module.exports = __webpack_public_path__ + "static/media/suno_ai.6dd7bb18.png";